"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.indeterminateIcon = exports.uncheckedIcon = exports.checkedIcon = undefined;

var _react = require("react");

var _react2 = _interopRequireDefault(_react);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var checkedIcon = function checkedIcon(_ref) {
  var style = _ref.style,
      _ref$size = _ref.size,
      size = _ref$size === undefined ? 24 : _ref$size,
      className = _ref.className;
  return _react2.default.createElement(
    "svg",
    {
      height: size,
      viewBox: "0 0 24 24",
      className: className,
      width: size,
      style: style
    },
    _react2.default.createElement("path", { d: "M19 3H5c-1.11 0-2 .9-2 2v14c0 1.1.89 2 2 2h14c1.11 0 2-.9 2-2V5c0-1.1-.89-2-2-2zm-9 14l-5-5 1.41-1.41L10 14.17l7.59-7.59L19 8l-9 9z" })
  );
}; /**
    * Copyright (c) 2015-present, Zippy Technologies
    *
    * This source code is licensed under the MIT license found in the
    * LICENSE file in the root directory of this source tree.
    */

var uncheckedIcon = function uncheckedIcon(_ref2) {
  var style = _ref2.style,
      _ref2$size = _ref2.size,
      size = _ref2$size === undefined ? 24 : _ref2$size,
      className = _ref2.className;
  return _react2.default.createElement(
    "svg",
    {
      height: size,
      viewBox: "0 0 24 24",
      className: className,
      width: size,
      style: style
    },
    _react2.default.createElement("path", { d: "M19 5v14H5V5h14m0-2H5c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2z" })
  );
};

var indeterminateIcon = function indeterminateIcon(_ref3) {
  var style = _ref3.style,
      _ref3$size = _ref3.size,
      size = _ref3$size === undefined ? 24 : _ref3$size,
      className = _ref3.className;
  return _react2.default.createElement(
    "svg",
    {
      height: size,
      viewBox: "0 0 24 24",
      className: className,
      width: size,
      style: style
    },
    _react2.default.createElement(
      "defs",
      null,
      _react2.default.createElement("path", { d: "M0 0h24v24H0z", id: "a" })
    ),
    _react2.default.createElement(
      "clipPath",
      { id: "b" },
      _react2.default.createElement("use", { overflow: "visible" })
    ),
    _react2.default.createElement("path", { d: "M19 3H5c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2zm-2 10H7v-2h10v2z" })
  );
};

exports.checkedIcon = checkedIcon;
exports.uncheckedIcon = uncheckedIcon;
exports.indeterminateIcon = indeterminateIcon;